// BookingCard.tsx
import React from 'react';
import { Card, CardContent, Box, Skeleton } from '@mui/material';
import styled from 'styled-components';

const StyledButtonWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  flex: 0.2,
  justifyContent: 'flex-end',
  alignItems: 'center',
  width: '100%',
}));

const StyledCardContent = styled(CardContent)(() => ({
  display: 'flex',
  flexDirection: 'row',
  height: '100%',
  alignItems: 'center',
  margin: '10px 5px',
  minHeight: '150px',
  backgroundColor: 'rgba(255, 221, 200, 0.2)',
  borderRadius: '10px',
  position: 'relative',
  justifyContent: 'space-between',
}));

const StyledBookingContactsBox = styled(Box)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  minHeight: '45px',
  padding: '10px 0 0 0',
  justifyContent: 'flex-start',
  maxWidth: '100%',
}));

const LoadingBookingCard = () => (
  <Card variant="outlined" sx={{ border: 'none', px: '10px' }}>
    <StyledCardContent>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        minWidth="80px"
        flex={0.05}
      >
        <Skeleton
          variant="rectangular"
          width="100%"
          height={20}
          sx={{ borderRadius: '10px', marginBottom: '5px' }}
        />
        <Skeleton variant="rectangular" width="100%" height={20} sx={{ borderRadius: '10px' }} />
      </Box>
      <Box display="flex" flexDirection="row" width="100%" flex={0.9} ml={1}>
        <Skeleton variant="circular" width={60} height={60} />
        <Box display="flex" flexDirection="column" px="10px" minWidth="100px" flex={0.7}>
          <Skeleton variant="text" width="60%" height={30} />
          <StyledBookingContactsBox>
            <Skeleton variant="text" width="40%" />
            <Skeleton variant="text" width="40%" />
          </StyledBookingContactsBox>
        </Box>
        <StyledButtonWrapper>
          <Skeleton
            variant="rectangular"
            width={100}
            height={35}
            sx={{ m: 1, borderRadius: '10px' }}
          />
          <Skeleton variant="circular" width={40} height={40} />
        </StyledButtonWrapper>
      </Box>
    </StyledCardContent>
  </Card>
);

export default LoadingBookingCard;
